import { render, staticRenderFns } from "./CarPosition.vue?vue&type=template&id=04317b04&scoped=true&"
import script from "./CarPosition.vue?vue&type=script&lang=js&"
export * from "./CarPosition.vue?vue&type=script&lang=js&"
import style0 from "./CarPosition.vue?vue&type=style&index=0&id=04317b04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04317b04",
  null
  
)

export default component.exports